import { getNonBootUserConfigurationSync } from 'owa-nonboot-userconfiguration-manager';

export default function externalInOutlookEnabled() {
    const { ExternalInOutlookEnabled = false } = getNonBootUserConfigurationSync() || {};
    return ExternalInOutlookEnabled;
}
